var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVariant2 = function SvgVariant2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 172 172"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 86,
    r: 71.418,
    stroke: "#F07D00",
    strokeDasharray: "0.1 4",
    strokeLinecap: "round",
    transform: "rotate(90 86 86)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F07D00",
    d: "m107.491 12.481 4.632-2.068 2.647 4.328 9.865 3.063-9.821-16.06L97.627 9.42z",
    opacity: 0.3
  })));
};
export default SvgVariant2;